import React from 'react';

import { Input } from 'components/WrappedComponents';
import { FormPlaceholders } from 'types/enums/FormPlaceholders';
import { CSSUtils } from 'utils/CSSUtils';

import { FormFilterFieldCentreVHU } from '../../types';

function InputNumeroAgrement({
  values,
}: FormFilterFieldCentreVHU): React.ReactElement {
  return (
    <Input
      wrapperProps={{
        values: values,
        fieldKey: 'numeroAgrement',
        itemProps: {
          label: "Numéro d'agrément",
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.largeWrapperCol },
        },
      }}
      inputProps={{ placeholder: FormPlaceholders.Input }}
    />
  );
}

export default InputNumeroAgrement;
